import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { firebaseConfig } from '../environments/environment';
import { Facebook } from '@ionic-native/facebook/ngx';
import { AngularFirestoreModule } from '@angular/fire/firestore';

// Plugins
import { GooglePlus } from '@ionic-native/google-plus/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { CookieService } from 'ngx-cookie-service';
import { IonicStorageModule } from '@ionic/storage';
import { JwtModule } from '@auth0/angular-jwt';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { CalendarModule } from 'ion2-calendar';
import { QRScanner } from '@ionic-native/qr-scanner/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Device } from '@ionic-native/device/ngx';
import { AnalyticsService} from 'src/app/services/analytics.service';

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(firebaseConfig),
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    IonicStorageModule.forRoot(),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['http://localhost:8100/', 'http://ws.localhost/'],
        disallowedRoutes: ['http://example.com/examplebadroute/'],
      },
    }),
    NgxQRCodeModule,
    CalendarModule,
  ],

  providers: [
    GooglePlus,
    StatusBar,
    SplashScreen,
    Facebook,
    BarcodeScanner,
    CookieService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    File,
    FileOpener,
    QRScanner,
    InAppBrowser,
    Device,
    AnalyticsService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
